import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
axios.defaults.headers.post['Content-Type'] = 'application/json'

export default {
  AXlogin (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/authen', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXconfig (url, success, error) {
    Vue.axios.get(url + '/PGws/config').then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXitems (url, success, error) {
    Vue.axios.get(url + '/PGws/items').then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXbill (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/bill/detail', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXdownloadtmp (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/download/folder', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXzipfile (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/download/zipfile', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXbilllist (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/bills', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXdeletebill (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/bills/delete', obj).then(
      (response) => {
        success(response)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXreportdayExpert (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/report/todayExpert', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXreportday (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/report/today', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXreportmonth (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/report/month', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXreportcom (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/report/commission', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXprofile (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/user/profile', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXchangepass (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/user/password', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXupdateexpired (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/update/date', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXcheckbill (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/checkbill', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXgetDoc (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/gendoc', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXupload_cloud (url, obj, header, success, error) {
    Vue.axios.post(url + '/PGws/upload_cloud', obj, header).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXaddemail (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/addemail', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXsendemail (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/sendemail', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXdeleteimages (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/delete/file', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  searchEmail (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/email/search', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  exportEmail (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/email/date', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  getStorage (url, success, error) {
    Vue.axios.get(url + '/PGws/storage').then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  clearStorage (url, obj, success, error) {
    Vue.axios.post(url + '/PGws/clear/storage', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  },
  AXuploadGoogle (url, obj, success, error) {
    Vue.axios.post(url + '/backup/google', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/service/services.js